// NavigationBar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Menu, X, ChevronRight, ChevronDown, User, PlayCircle, Grid3X3 } from 'lucide-react';

const NavigationBar = ({ 
  isAuthenticated, 
  currentUser, 
  onLoginClick, 
  onRegisterClick, 
  onLogout, 
  toggleDashboard, 
  setCurrentView, // ← Recibir esta prop
  scrollToSection,
  handleNavigate, // ← Agregar esta prop para la navegación a productos
  onHome // ← Si se pasa, Inicio navega de verdad (págs robotica / producto)
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
  const [isMobileProductsOpen, setIsMobileProductsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Lista de productos
  const products = [
    { name: 'Inventario IA', desc: 'Controla tu stock', route: 'nexusstock-landing' },
    { name: 'Pedidos IA', desc: 'Pedidos de tu restaurante', route: 'nexusorders-landing' },
    { name: 'Tienda IA', desc: 'Vende por WhatsApp, Instagram y Facebook', route: 'nexuscommerce-landing' },
    { name: 'Clientes IA', desc: 'Clientes, citas y pagos', route: 'solar-ai-landing' },
    { name: 'Condominios IA', desc: 'Administra tu edificio', route: 'condominios-landing' },
    { name: 'Tours 3D', desc: 'Recorridos 3D de propiedades', route: 'nexustour-landing' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProductsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleProductClick = (route) => {
    if (handleNavigate) {
      handleNavigate(route);
    }
    setIsProductsDropdownOpen(false);
    setIsMenuOpen(false);
  };

  const handleTutorialsClick = () => {
    if (setCurrentView) {
      setCurrentView('tutorials');
    }
    setIsProductsDropdownOpen(false);
    setIsMenuOpen(false);
  };

  const toggleProductsDropdown = () => {
    setIsProductsDropdownOpen(!isProductsDropdownOpen);
  };

  const toggleMobileProducts = () => {
    setIsMobileProductsOpen(!isMobileProductsOpen);
  };

  return (
    <>
      <nav className={`fixed w-full z-40 transition-all duration-700 ease-in-out ${isScrolled ? 'py-4' : 'py-6'}`}>
        <div className={`container mx-auto px-6 transition-all duration-700 ease-in-out ${isScrolled ? 'max-w-6xl' : ''}`}>
          <div
            className={`flex justify-between items-center transition-all duration-700 ease-in-out ${isScrolled ? 'backdrop-blur-xl rounded-full px-8 py-4' : 'px-0 py-0'}`}
            style={{
              background: isScrolled ? 'rgba(17, 24, 39, 0.85)' : 'transparent',
              border: isScrolled ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid transparent',
              boxShadow: isScrolled ? '0 8px 32px rgba(139, 92, 246, 0.4), 0 0 0 1px rgba(139, 92, 246, 0.1)' : 'none'
            }}>
            <div className="flex items-center">
              <span className="text-2xl font-black tracking-tighter">
                <span style={{
                  background: 'linear-gradient(to right, #8b5cf6, #ec4899)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>Nexus</span>
                <span style={{ color: '#ffffff' }}>AI</span>
              </span>
            </div>

          {/* Menú de escritorio */}
          <div className="hidden md:flex space-x-8 items-center">
            <button
              onClick={() => (onHome ? onHome() : scrollToSection('inicio'))}
              className="text-sm font-medium transition-all duration-300 hover:scale-105"
              style={{ color: '#f3f4f6' }}
            >
              Inicio
            </button>

            {/* Dropdown de Productos */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={toggleProductsDropdown}
                className="text-sm font-medium transition-all duration-300 flex items-center space-x-1 hover:scale-105"
                style={{ color: '#f3f4f6' }}
              >
                <span>Productos</span>
                <ChevronDown size={16} className={`transform transition-transform ${isProductsDropdownOpen ? 'rotate-180' : ''}`} />
              </button>

              {/* Dropdown Menu */}
              {isProductsDropdownOpen && (
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-3 w-56 rounded-xl py-2 z-50 backdrop-blur-xl" style={{
                  background: 'rgba(17, 24, 39, 0.9)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
                }}>
                  {/* Sección de Productos */}
                  <div className="px-3 py-2">
                    <p className="text-xs font-semibold uppercase tracking-wider" style={{ color: '#9ca3af' }}>Productos</p>
                  </div>
                  {products.map((product, index) => (
                    <button
                      key={index}
                      onClick={() => handleProductClick(product.route)}
                      className="w-full text-left px-4 py-2 transition-all duration-300 rounded-lg"
                      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.1)'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                    >
                      <span className="block text-sm font-medium" style={{ color: '#f3f4f6' }}>{product.name}</span>
                      <span className="block text-xs" style={{ color: '#9ca3af' }}>{product.desc}</span>
                    </button>
                  ))}

                  {/* Separador */}
                  <div className="my-2" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}></div>

                  {/* Botón Ver todos los productos */}
                  <button
                    onClick={() => handleProductClick('productos')}
                    className="w-full text-left px-4 py-3 text-sm font-medium flex items-center space-x-2 rounded-lg"
                    style={{
                      background: 'transparent',
                      color: '#ffffff'
                    }}
                  >
                    <Grid3X3 size={16} />
                    <span>Ver todos los productos</span>
                  </button>

                  {/* Separador */}
                  <div className="my-2" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}></div>

                  {/* Botón de Tutoriales */}
                  <button
                    onClick={handleTutorialsClick}
                    className="w-full text-left px-4 py-3 text-sm font-medium transition-all duration-300 flex items-center space-x-2 rounded-lg"
                    style={{
                      background: 'linear-gradient(to right, rgba(139, 92, 246, 0.1), rgba(236, 72, 153, 0.1))',
                      color: '#a78bfa'
                    }}
                  >
                    <PlayCircle size={16} />
                    <span>Ver Tutoriales</span>
                  </button>


                </div>
              )}
            </div>


            <button
              onClick={() => setCurrentView('web-development')}
              className="text-sm font-medium transition-all duration-300 hover:scale-105"
              style={{ color: '#f3f4f6' }}
            >
              Desarrollo Web
            </button>
            <button
              onClick={() => setCurrentView('robotica')}
              className="text-sm font-medium transition-all duration-300 hover:scale-105"
              style={{ color: '#f3f4f6' }}
            >
              Robótica
            </button>
            <button
              onClick={() => setCurrentView('help-center')}
              className="text-sm font-medium transition-all duration-300 hover:scale-105"
              style={{ color: '#f3f4f6' }}
            >
              Ayuda
            </button>

            {isAuthenticated ? (
              <div className="flex space-x-4">
                <button
                  onClick={toggleDashboard}
                  className="text-sm font-medium transition-all duration-300 flex items-center space-x-1 hover:scale-105"
                  style={{ color: '#f3f4f6' }}
                >
                  <User size={16} />
                  <span>{(currentUser?.name || currentUser?.full_name || '').split(' ')[0]}</span>
                </button>

                <button
                  onClick={onLogout}
                  className="px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center space-x-1 hover:scale-105"
                  style={{
                    background: 'linear-gradient(to right, #8b5cf6, #ec4899)',
                    color: '#ffffff'
                  }}
                >
                  <span>Salir</span>
                </button>
              </div>
            ) : (
              <div className="flex space-x-4">
                <button
                  onClick={onLoginClick}
                  className="text-sm font-medium transition-all duration-300 hover:scale-105"
                  style={{ color: '#f3f4f6' }}
                >
                  Acceder
                </button>

                <button
                  onClick={onRegisterClick}
                  className="px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center space-x-1 hover:scale-105"
                  style={{
                    background: 'linear-gradient(to right, #8b5cf6, #ec4899)',
                    color: '#ffffff'
                  }}
                >
                  <span>Registrarse</span>
                  <ChevronRight size={16} />
                </button>
              </div>
            )}
          </div>

          {/* Botón de menú móvil */}
          <button
            className="md:hidden"
            onClick={toggleMenu}
            style={{ color: '#ffffff' }}
          >
            {isMenuOpen ?
              <X size={24} /> :
              <Menu size={24} />}
          </button>
          </div>
        </div>

        {/* Menú móvil */}
        {isMenuOpen && (
          <div className="md:hidden shadow-xl absolute w-full mt-4 mx-6 rounded-2xl backdrop-blur-xl" style={{
            background: 'rgba(17, 24, 39, 0.95)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            maxWidth: 'calc(100% - 48px)'
          }}>
            <div className="px-6 py-4 flex flex-col space-y-4">
              <button
                onClick={() => {
                  if (onHome) { onHome(); return; }
                  scrollToSection('inicio');
                  setIsMenuOpen(false);
                }}
                className="text-left py-2 font-medium transition-colors"
                style={{ color: '#f3f4f6' }}
              >
                Inicio
              </button>

              {/* Productos desplegable móvil */}
              <div>
                <button
                  onClick={toggleMobileProducts}
                  className="text-left py-2 font-medium transition-colors flex items-center justify-between w-full"
                  style={{ color: '#f3f4f6' }}
                >
                  <span>Productos</span>
                  <ChevronDown size={16} className={`transform transition-transform ${isMobileProductsOpen ? 'rotate-180' : ''}`} />
                </button>
                
                {isMobileProductsOpen && (
                  <div className="ml-4 mt-2 space-y-2">
                    {products.map((product, index) => (
                      <button
                        key={index}
                        onClick={() => handleProductClick(product.route)}
                        className="block w-full text-left py-2 transition-colors"
                      >
                        <span className="block text-sm text-gray-300">{product.name}</span>
                        <span className="block text-xs text-gray-500">{product.desc}</span>
                      </button>
                    ))}

                    {/* Separador móvil */}
                    <div className="border-t border-gray-600 my-2"></div>

                    {/* Ver todos los productos en móvil */}
                    <button
                      onClick={() => handleProductClick('productos')}
                      className="block w-full text-left py-2 text-indigo-400 hover:text-indigo-300 transition-colors text-sm font-medium flex items-center space-x-2"
                    >
                      <Grid3X3 size={16} />
                      <span>Ver todos los productos</span>
                    </button>

                    {/* Separador móvil */}
                    <div className="border-t border-gray-600 my-2"></div>

                    {/* Tutoriales en móvil */}
                    <button
                      onClick={handleTutorialsClick}
                      className="block w-full text-left py-2 text-indigo-400 hover:text-indigo-300 transition-colors text-sm font-medium flex items-center space-x-2"
                    >
                      <PlayCircle size={16} />
                      <span>Ver Tutoriales</span>
                    </button>
                  </div>
                )}
              </div>
              
              <button 
                onClick={() => {
                  setCurrentView('web-development');
                  setIsMenuOpen(false);
                }} 
                className="text-left py-2 text-gray-200 font-medium hover:text-indigo-400 transition-colors"
              >
                Desarrollo Web
              </button>
              <button 
                onClick={() => {
                  setCurrentView('robotica');
                  setIsMenuOpen(false);
                }} 
                className="text-left py-2 text-gray-200 font-medium hover:text-indigo-400 transition-colors"
              >
                Robótica
              </button>
              <button
                onClick={() => {
                  setCurrentView('help-center');
                  setIsMenuOpen(false);
                }}
                className="text-left py-2 text-gray-200 font-medium hover:text-indigo-400 transition-colors"
              >
                Ayuda
              </button>
              <button
                onClick={() => {
                  setCurrentView('about');
                  setIsMenuOpen(false);
                }}
                className="text-left py-2 text-gray-200 font-medium hover:text-indigo-400 transition-colors"
              >
                Sobre Nosotros
              </button>
              <button 
                onClick={() => {
                  setCurrentView('team');
                  setIsMenuOpen(false);
                }} 
                className="text-left py-2 text-gray-200 font-medium hover:text-indigo-400 transition-colors"
              >
                Equipo
              </button>
              
              {isAuthenticated ? (
                <>
                  <button 
                    onClick={toggleDashboard}
                    className="text-left py-2 text-gray-200 font-medium hover:text-indigo-400 transition-colors flex items-center space-x-2"
                  >
                    <User size={16} />
                    <span>Mi Dashboard</span>
                  </button>
                  <button 
                    onClick={onLogout} 
                    className="bg-indigo-600 text-white py-3 rounded-md text-center font-medium hover:bg-indigo-700 transition-colors"
                  >
                    Cerrar Sesión
                  </button>
                </>
              ) : (
                <>
                  <button 
                    onClick={onLoginClick} 
                    className="text-left py-2 text-gray-200 font-medium hover:text-indigo-400 transition-colors"
                  >
                    Iniciar Sesión
                  </button>
                  <button 
                    onClick={onRegisterClick} 
                    className="bg-indigo-600 text-white py-3 rounded-md text-center font-medium hover:bg-indigo-700 transition-colors"
                  >
                    Registrarse
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default NavigationBar;
